var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: { width: "100%", "margin-top": "2px" }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclarationInfo")))
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticStyle: { flex: "1" } },
              [
                !_vm.isSalesForSzfs
                  ? _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "50px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.CustomsBroker") }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                no: "customsBroker",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "data-filter-function": _vm.customsBrokerFilter,
                                filterable: "",
                                "default-value": _vm.job.customsBroker || "",
                                "method-params": {
                                  customsBroker: true,
                                  companyLob: "seaExport",
                                  active: true
                                }
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.job.customsBroker = p.value || 0
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "50px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Remarks") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "customsRemarks",
                            type: "textarea",
                            rows: 5
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Remarks"),
                                _vm.job.customsRemarks,
                                function(val) {
                                  _vm.job.customsRemarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.customsRemarks,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customsRemarks", $$v)
                            },
                            expression: "job.customsRemarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { flex: "1", "margin-left": "10px" } },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "90px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AdvancePayment") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { no: "advancePayment" },
                            on: { change: _vm.handleAdvancePaymentChange },
                            model: {
                              value: _vm.advancePaymentValue,
                              callback: function($$v) {
                                _vm.advancePaymentValue = $$v
                              },
                              expression: "advancePaymentValue"
                            }
                          },
                          _vm._l(_vm.SystemConstants.YESORNO_STATES, function(
                            item
                          ) {
                            return _c("el-option", {
                              key: item.code,
                              attrs: {
                                label:
                                  _vm.$store.getters.language === "zh"
                                    ? item.chineseName
                                    : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "90px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.TaxRemarks") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "taxRemarks",
                            type: "textarea",
                            rows: 5
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.TaxRemarks"),
                                _vm.job.taxRemarks,
                                function(val) {
                                  _vm.job.taxRemarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.taxRemarks,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "taxRemarks", $$v)
                            },
                            expression: "job.taxRemarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { flex: "1", "margin-left": "10px" } },
              [
                _c(
                  "el-form",
                  { attrs: { disabled: _vm.readonly, "label-width": "90px" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.CustomsDutyAmount") }
                      },
                      [
                        _c("auto-number-input", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "customsDutyAmount",
                            precision: 2,
                            disabled: _vm.readonly,
                            min: 0
                          },
                          model: {
                            value: _vm.job.customsDutyAmount,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customsDutyAmount", $$v)
                            },
                            expression: "job.customsDutyAmount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { flex: "1", "margin-left": "10px" } },
              [
                _c(
                  "el-form",
                  { attrs: { disabled: _vm.readonly } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.VatAmount") } },
                      [
                        _c("auto-number-input", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "vatAmount",
                            precision: 2,
                            disabled: _vm.readonly,
                            min: 0
                          },
                          model: {
                            value: _vm.job.vatAmount,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "vatAmount", $$v)
                            },
                            expression: "job.vatAmount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { flex: "1", "margin-left": "10px" } },
              [
                _c(
                  "el-form",
                  { attrs: { disabled: _vm.readonly } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PaymentTime") } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            no: "paymentTime",
                            disabled: _vm.readonly,
                            type: "date",
                            clearable: "",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.job.paymentTime,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "paymentTime", $$v)
                            },
                            expression: "job.paymentTime"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c("div", { staticClass: "operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "NewCustomsDeclaration",
                      type: "primary",
                      disabled:
                        !_vm.btnEnable || (_vm.isEdit && _vm.openXhqCustomsAll)
                    },
                    on: { click: _vm.addCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.NewCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "EditCustomsDeclaration",
                      type: "primary",
                      disabled:
                        !_vm.btnEnable ||
                        (_vm.isEdit &&
                          (_vm.openXhqCustoms || _vm.openXhqCustomsAll))
                    },
                    on: { click: _vm.editCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.EditCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.openXhqCustomsAll || _vm.openMeiHuaCustom,
                        expression: "!openXhqCustomsAll || openMeiHuaCustom"
                      }
                    ],
                    attrs: {
                      no: "DeleteCustomsDeclaration",
                      type: "danger",
                      disabled: !_vm.btnEnable
                    },
                    on: { click: _vm.delCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.openXhqCustomsAll && !_vm.openMeiHuaCustom,
                        expression: "openXhqCustomsAll && !openMeiHuaCustom"
                      },
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_customs_forceDelete"],
                        expression: "['button_customs_forceDelete']"
                      }
                    ],
                    attrs: {
                      no: "xhqDeleteCustomsDeclaration",
                      type: "danger",
                      disabled: !_vm.btnEnable || _vm.isEdit
                    },
                    on: { click: _vm.xhqDelCustInfoHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteCustomsDeclaration")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.openXhqCustomsAll && !_vm.openMeiHuaCustom,
                        expression: "openXhqCustomsAll && !openMeiHuaCustom"
                      }
                    ],
                    attrs: {
                      no: "xhqCustomsUnFrozen",
                      type: "primary",
                      disabled: !_vm.btnEnable || _vm.isEdit
                    },
                    on: { click: _vm.toXhqCustomsUnFrozenHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.UnFrozen")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.openXhqCustoms || _vm.openXhqCustomsAll) &&
                          !_vm.openMeiHuaCustom,
                        expression:
                          "(openXhqCustoms || openXhqCustomsAll) && !openMeiHuaCustom"
                      }
                    ],
                    attrs: {
                      no: "GetCustomsFile",
                      type: "primary",
                      disabled:
                        !_vm.btnEnable ||
                        !(_vm.job.jobState === 0) ||
                        _vm.isEdit
                    },
                    on: { click: _vm.getCustomsFile }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.GetFiles")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.closeXhqCustoms &&
                          !_vm.openOujianCustoms &&
                          _vm.job.lob === "SE",
                        expression:
                          "closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'"
                      }
                    ],
                    attrs: {
                      no: "GetOcrFile",
                      type: "primary",
                      disabled:
                        _vm.job.jobState !== 0 ||
                        _vm.isEdit ||
                        !_vm.$checkPermission([
                          "button_customs_IdentifyTheCustoms"
                        ])
                    },
                    on: { click: _vm.getOcrFileHandler }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("CargoMsg.Cargo_IdentifyTheCustomsDeclaration")
                      )
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.closeXhqCustoms &&
                          !_vm.openOujianCustoms &&
                          _vm.job.lob === "SE",
                        expression:
                          "closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'"
                      }
                    ],
                    attrs: {
                      no: "RefreshOcrFile",
                      type: "primary",
                      disabled: _vm.job.jobState !== 0 || _vm.isEdit
                    },
                    on: { click: _vm.loadList }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_RefreshCustomsDeclaration"))
                    )
                  ]
                )
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: { flex: "1", "margin-top": "5px" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "config-module": _vm.closeXhqCustoms ? "20240830" : "20240831",
              "column-defs": _vm.closeXhqCustoms
                ? _vm.columnDefs
                : _vm.xhqColumnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("customs-info-dialog", {
        ref: "customsInfoDialog",
        attrs: {
          "customs-infos": _vm.rowData,
          "slave-customs-declaration-enable": _vm.slaveCustomsDeclarationEnable,
          visible: _vm.editDialog.visible,
          "is-sales-for-szfs": _vm.isSalesForSzfs,
          "selected-customs-info": _vm.selectedCustomsInfo,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler,
          loadList: _vm.loadList
        }
      }),
      _c("customs-info-dialog-ouj", {
        ref: "customsInfoDialogOuj",
        attrs: {
          visible: _vm.editOujianDialog.visible,
          "selected-customs-info": _vm.editOujianDialog.customsInfo,
          job: _vm.editOujianDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editOujianDialog, "visible", $event)
          },
          successHandler: _vm.successHandler,
          close: function($event) {
            _vm.editOujianDialog.visible = false
          }
        }
      }),
      _c("customs-info-interact-res-dialog", {
        ref: "customsInfoInteractResDialog",
        attrs: {
          visible: _vm.interactResDialog.visible,
          "customs-id": _vm.interactResDialog.customsId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.interactResDialog, "visible", $event)
          }
        }
      }),
      _c("file-history-dialog", {
        ref: "fileHistoryDialog",
        attrs: {
          visible: _vm.fileHistoryDialog.visible,
          "customs-id": _vm.fileHistoryDialog.customsId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fileHistoryDialog, "visible", $event)
          }
        }
      }),
      _c("information-comparison-dialog", {
        ref: "informationComparisonDialog",
        attrs: {
          visible: _vm.informationComparisonDialog.visible,
          data: _vm.informationComparisonDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.informationComparisonDialog, "visible", $event)
          }
        }
      }),
      _c("customs-receipt-record-dialog", {
        ref: "customsReceiptRecordDialog",
        attrs: {
          visible: _vm.customsReceiptRecordDialog.visible,
          "selected-customs-info": _vm.customsReceiptRecordDialog.customsInfo
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customsReceiptRecordDialog, "visible", $event)
          }
        }
      }),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.job.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "advanceText",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "warning-count": -1,
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.closeXhqCustoms && _vm.job.lob === "SE"
        ? _c("drop-uploader", {
            ref: "dropUploader",
            attrs: {
              action: _vm.URL.AIdiscern.importAndAnalyseFile,
              "upload-params": {
                source: _vm.INTELLIGENT_DOCUMENT_SOURCE_9.code,
                iChannel: 3,
                jobUuid: _vm.job.uuid,
                pageSource: "customsInfo",
                officeId: _vm.$store.getters.currentOfficeId
              },
              accept: [
                "pdf",
                "xls",
                "xlsx",
                "doc",
                "docx",
                "jpg",
                "gif",
                "png",
                "tif",
                "msword",
                "ms-excel",
                "jpeg",
                "rtf"
              ],
              "file-format": _vm.fileFormat,
              multiple: false,
              "open-drag": false,
              "bs-open": _vm.bsOpen
            },
            on: { "upload-result": _vm.uploadResultHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }